import { Injectable } from '@angular/core';
import { Metas } from '../../shared/services/utilities/seo.service';
import { environment } from 'environments/environment';
import { StringUtilities } from '../../utils/misc/string-utilities';
import { getTranslation } from '../../utils/const/translation';
import { DisplayPost } from '../../shared/models/publication';

@Injectable()
export class PostMetasService {

  constructor() { }

  getPostMetas(post: DisplayPost): Metas {
    const postType = getTranslation('post.postTypes.' + post.type);
    const tagName = (post.tags.length && typeof post.tags[0] !== 'string') ? post.tags[0].name : '';
    const userName = (typeof post.author !== 'string') ? post.author.username : null;
    const description = StringUtilities.shorten((post.description === null) ? '' : post.description, 29, '...', true);

    const title = (post.tags.length) ?
      $localize`:@@meta.post.title:${userName}:username:\'s ${postType}:postType: ${tagName}:tagName: | ${description}:description:` :
      $localize`:@@meta.post.titleNoTag:${postType}:postType: ${userName}:username: | ${description}:description:`;

    post.medias.sort((a, b) => a.weight - b.weight);
    const image = (post.medias[0]) ? post.medias[0].media.thumbs.big :
        `${environment.REDIRECT_URL}/assets/images/posts/event-empty-pictures.jpg`;
    return { title, description: StringUtilities.shorten(description, 120, '...', true), image };
  }

}
